import { DefaultsApi, useAPIQuery } from "melco-shared-logic";

export const useGetRefferalSalesPersons = () => {
    return useAPIQuery(
        DefaultsApi,
        ["getRefferalSalesPersons"],
        async (api) => {
            const response = await api.defaultsGetSalesReferralList();
            return response;
            // }
        },

    );
};